import { extendTheme } from "@chakra-ui/react";
import { lexicalStyles } from './LexicalTheme';

export const themes = {
  colors: {
    brand: {
      blue: {
        50: '#cbe3ff',
        100: '#beddff',
        200: '#97c8ff',
        300: '#6fb3ff',
        400: '#489fff',
        500: '#0a84ff', //main
        600: '#0063d2',
        700: '#0051aa',
        800: '#003e83',
        900: '#00356f',
      },
      red: {
        50: '#ffa29c',
        100: '#ff8f88',
        200: '#ff7d75',
        300: '#ff6a61',
        400: '#ff584e',
        500: '#ff453a', //main
        600: '#d70c00',
        700: '#c30b00',
        800: '#b00a00',
        900: '#9c0900',
      },
      green: {
        50: '#b0e2a9',
        100: '#a0dc98',
        200: '#90d687',
        300: '#80d076',
        400: '#70ca65',
        500: '#34c759', //main
        600: '#57b14b',
        700: '#4d9d43',
        800: '#43893a',
        900: '#3a7632',
      },
      darkPrimary: "#0071EE",
      darkGray: "#718096",
      veryDarkGray: "#2A2F3A",
      mediumGray: "#E2E8F0",
      gray: "#F1F3F6",
      blackCrowBlack: "#1C1C1C",
      blackCrowGrey: "#A3A7AC",
      blackCrowGreen: "#6AFA97",
      blackCrowCream: '#E9E8E8',
      blackCrowBrightGreen: '#0bdd4d',
    },
  },
  fonts: {
    regular: '16px',
    sm: '14px',
    xs: '12px',
    xxs: '8px',
    light: `'PPFragment Sans Light', sans-serif`,
    regular: `'PPFragment Sans Regular', sans-serif`,
    medium: `'PPFragment Sans Medium', sans-serif`,
  },
  border: {
    radius: '8px',
    radiusNumber: 8,
  },
  button: {
    radius: '6px',
    radiusNumber: 6,
  }
};

export const vizzlyTheme = {
  colors: [themes.colors.brand.blue['500'], '#C33D69', '#2EA597', '#8456CE', '#E07941', '#3759CE'],
  Header: {
    title: {
      fontSize: 24,
      fontWeight: 700,
      color: '#000',
    },
  },
  charts: {
    title: {
      fontSize: 18,
      fontWeight: 700,
      color: '#000',
    },
    labels: {
      color: themes.colors.brand.veryDarkGray,
      fontWeight: 500,
      fontSize: 11,
    },
    grid: {
      stroke: themes.colors.brand.mediumGray,
    },
  },
  popoverMenu: {
    background: '#fff',
    border: `1px solid ${themes.colors.brand.mediumGray}`,
    '&:hover': { background: themes.colors.brand.mediumGray },
  },
  panels: {
    background: '#fff',
    border: `1px solid ${themes.colors.brand.mediumGray}`,
    boxShadow: 'none',
  },
  dropdowns: {
    '&:hover': {
      background: '',
    },
  },
};

const overrides = {
  colors: {
    blue: { ...themes.colors.brand.blue },
    red: { ...themes.colors.brand.red },
    green: { ...themes.colors.brand.green },
    blackCrowBrightGreen: themes.colors.brand.blackCrowBrightGreen,
    blackCrowBlack: themes.colors.brand.blackCrowBlack,
    blackCrowGrey: themes.colors.brand.blackCrowGrey,
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: themes.button.radius,
        fontWeight: 'bold',
        _disabled: {
          _hover: {
            bg: 'unset',
            color: 'initial',
          },
        },
      },
      variants: {
        blackCrowPrimary: {
          bg: themes.colors.brand.blackCrowGreen,
          color: themes.colors.brand.blackCrowBlack,
          _hover: {
            opacity: 0.7
          }
        },
        blackCrowSecondary: {
          bg: themes.colors.brand.blackCrowBlack,
          color: themes.colors.brand.blackCrowCream,
          _hover: {
            opacity: 0.7
          }
        }
      }
    },
    Heading: {
      defaultProps: {
        size: 'lg',
      },
    },
    Badge: {
      defaultProps: {},
      baseStyle: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingX: 2,
        paddingY: 1,
        borderRadius: themes.border.radius,
        fontSize: themes.fonts.xs,
        fontWeight: 500,
      },
    },
  },
  styles: {
    global: {
      "@font-face": [
        {
          fontFamily: 'PPFragment Sans Light',
          src: `url('https://res.cloudinary.com/viddyapp/raw/upload/v1726722691/PPFragment-SansLight_sbtcc8.otf') format('opentype')`,
          fontWeight: '100',
          fontStyle: 'normal',
        },
        {
          fontFamily: 'PPFragment Sans Regular',
          src: `url('https://res.cloudinary.com/viddyapp/raw/upload/v1726723159/PPFragment-SansRegular_ew5uwz.otf') format('opentype')`,
          fontWeight: '400',
          fontStyle: 'normal',
        },
        {
          fontFamily: 'PPFragment Sans Medium',
          src: `url('https://res.cloudinary.com/viddyapp/raw/upload/v1726723159/PPFragment-SansMedium_ixxn12.otf') format('opentype')`,
          fontWeight: '500',
          fontStyle: 'normal',
        },
      ],
      ...lexicalStyles,
    },
  },
};


const theme = extendTheme(overrides);

export default theme;
